import { type ActivityStatusType } from '@pkg/types';

export type ActivityListEntryType = {
    uuid: string;
    id: string;
    name: string;
    image: string;
    owner_yat: string;
    twitter_handle: string;
    wallet_address: string;
    date: string;
    value: number;
    status: ActivityStatusType;
    contract_address: string;
    slug?: string;
};

export type ActivityListDataType = {
    active_wallets: number;
    entries: ActivityListEntryType[];
};

export enum DaasActivityFeedEventType {
    EthSaleEvent = 'ethSaleEvent',
    BidsEvent = 'ethBidEvent',
    ListingsEvent = 'ethListingEvent',
    TransferEvent = 'ethTransferEvent',
    FloorPriceEvent = 'ethFloorPriceEvent',
}

export type SignatureType =
    | 'Transfer(address,address,uint256)'
    | 'TransferSingle(address,address,address,uint256,uint256)'
    | 'TransferBatch(address,address,address,uint256[],uint256[])'
    | 'PunkTransfer(address,address,uint256)'
    | 'PunkOffered(uint,uint,address)'
    | 'PunkBidEntered(uint,uint,address)'
    | 'PunkBidWithdrawn(uint,uint,address)'
    | 'PunkBought(uint,uint,address,address)'
    | 'PunkNoLongerForSale(uint)'
    | 'Assign(address,uint256)'
    | 'Birth(address,uint256,uint256,uint256,uint256)'
    | 'buyRock(uint)';

export type EventParsedData = {
    contract_address: string;
    id: string;
    status: ActivityStatusType;
    date: string;
    value?: number;
    addressFrom: string;
    addressTo: string;
    expirationDate?: Date;
    isOwner?: boolean;
};
